import { Languages } from "src/common/descriptions/types";
import { CreateQuotationDescriptions } from "./types";

const DescriptionsEnUs: CreateQuotationDescriptions = {
    TITLE: "Create Quotation",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Save Quotation?',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Quotation input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Quotation Created",
    },
    MAIN_ACTION_TITLE: "Creating Quotation",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    DAYS: "days",
    STEPS: {
        INPUT_DATA: "Input Data",
        TEMPLATE: "Template",
    },
    FORM: {
        NAME: {
            LABEL: "Quotation Name",
            PLACEHOLDER: "Input Quotation Name",
        },
        CUSTOMER: {
            LABEL: "Customer",
            PLACEHOLDER: "Select customer",
        },
        CONTACT: {
            LABEL: "Contact",
            PLACEHOLDER: "Input Contact name",
        },
        ADDRESS: {
            LABEL: "Address",
            PLACEHOLDER: "Input Address",
        },
        EXPIRATION: {
            LABEL: "Expiration",
            PLACEHOLDER: "Input expiration",
        },
        STATUS: {
            LABEL: "Status",
            PLACEHOLDER: "Select status",
        },
        PHONE: {
            LABEL: "Phone",
            PLACEHOLDER: "Customer phone",
        },
        EMAIL: {
            LABEL: "Email",
            PLACEHOLDER: "Customer email",
        },
        NIT: {
            LABEL: "NIT",
            PLACEHOLDER: "Customer NIT",
        },
    },
    SAVING_BUTTON: "Saving...",
    DETAIL: {
        TITLE: "Quotation Detail",
        ADD_ITEM: "Add Item",
        EMPTY: {
            TITLE: "No items in quotation",
            DESCRIPTION: "Add product or services to build your quotation",
        },
        TABLE: {
            KEY: "No",
            DESCRIPTION: "Category / Service",
            QTY: "Qty",
            PRICE: "Price",
            TOTAL: "Total",
            ACTIONS: "Actions",
        },
        FORM: {
            TITLE: "Quotation Item",
            DESCRIPTION: {
                LABEL: "Description",
                PLACEHOLDER: "Input description",
            },
            QTY: {
                LABEL: "Qty",
                PLACEHOLDER: "Input qty",
            },
            PRICE: {
                LABEL: "Price",
                PLACEHOLDER: "Input price",
            },
            TOTAL: {
                LABEL: "Total",
                PLACEHOLDER: "Input total",
            },
            CANCEL: "Cancel",
            ACCEPT: "Accept",
            GREATER_THAN_ZERO: (fieldName: string) => `${fieldName} must be greater than 0`,
        },
        CHARACTERISTICS: "Characteristics",
    },
    POLICY: {
        TITLE: "Term and Conditions",
        ADD_ITEM: "Add Item",
        EMPTY: {
            TITLE: "No term nor conditions in quotation",
            DESCRIPTION: "Add term or conditions to build your quotation",
        },
        TABLE: {
            KEY: "No",
            DESCRIPTION: "Description",
            NAME: "Name",
            ACTIONS: "Actions",
        },
        FORM: {
            TITLE: "Term and Conditions",
            DESCRIPTION: {
                LABEL: "Description",
                PLACEHOLDER: "Input description",
            },
            NAME: {
                LABEL: "Name",
                PLACEHOLDER: "Input name",
            },
            CANCEL: "Cancel",
            ACCEPT: "Accept",
        },
    },
    TEMPLATE: {
        FORM: {
            TEMPLAT_NAME: {
                LABEL: "Template Name",
                PLACEHOLDER: "Select template name",
            },
            SALUTATION: {
                LABEL: "Salutation",
                PLACEHOLDER: "Input salutation",
            },
            BODY: {
                LABEL: "Body",
                PLACEHOLDER: "Input body",
            },
            CLOSE: {
                LABEL: "Close",
                PLACEHOLDER: "Input close",
            },
        },
        CANCEL: "Return",
        ACCEPT: "Preview",
    },
    PREVIEW: {
        TITLE: "Preview",
        RETURN: "Return",
        PRINT: "Print",
    },
    RECORDS: {
        TITLE: "Quotations",
        NEW_QUOTATION: "New quotation",
        SEARCH: "Search quotations",
        COLUMNS: {
            CODE: "Code",
            NAME: "Name",
            CUSTOMER: "Customer",
            STATUS: "Status",
            TOTAL: "Total",
            ACTIONS: "Actions",
        },
        ACTIONS: {
            VIEW: "View",
            GENERATE_PDF: "Generate PDF",
            SEND_TELEGRAM: "Send to Telegram",
            APPROVE: "Approve",
            REJECT: "Reject",
            MARK_DRAFT: "Mark as draft",
            DELETE: "Delete",
            MENU: "Actions",
        },
        CONFIRM: {
            APPROVE: "Approve quotation?",
            REJECT: "Reject quotation?",
            MARK_DRAFT: "Mark quotation as draft?",
            DELETE: "Delete quotation?",
            OK_APPROVE: "Approve",
            OK_REJECT: "Reject",
            OK_MARK_DRAFT: "Mark draft",
            OK_DELETE: "Delete",
            CANCEL: "Cancel",
        },
        STATUS_VALUES: {
            DRAFT: "Draft",
            SENT: "Sent",
            APPROVED: "Approved",
            REJECTED: "Rejected",
            DELETED: "Deleted",
        },
    },
    PDF_ACTIONS: {
        TITLE: "Send",
        ACTION: "Action",
        PDF_TITLE: "Generate PDF",
        TELEGRAM_TITLE: "Send to Telegram",
        TEMPLATE: "Template",
        SELECT_TEMPLATE: "Select template",
        SHOW_PRICES: "Show prices in proposal",
        BACK: "Back",
        GENERATE_PDF: "Generate PDF",
        SEND_TELEGRAM: "Send to Telegram",
        SENT_SUCCESS: "Quotation sent to Telegram",
        SAVE_FIRST: "Save the quotation before generating a PDF",
        SAVE_SUCCESS: "Quotation saved",
        NO_ACTIVE_TEMPLATES: "No active templates available.",
        ACTIVATE_TEMPLATE_HINT: "Activate a quotation template before generating or sending this document.",
    },
}

const DescriptionsEsUs: CreateQuotationDescriptions = {
    TITLE: "Crear Cotización",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: '¿Guardar Cotización?',
        DESCRIPTION: "La operación no poddrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "¿Cancelar ingreso de Cotización?",
        DESCRIPTION: "Los datos se perderán.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Éxito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Cotización Creada",
    },
    MAIN_ACTION_TITLE: "Creando Cotización",
    MAIN_ACTION_DESCRIPTION: "Por favor espera...",
    DAYS: "días",
    STEPS: {
        INPUT_DATA: "Ingreso de Datos",
        TEMPLATE: "Diseño e impresión",
    },
    FORM: {
        NAME: {
            LABEL: "Nombre Cotización",
            PLACEHOLDER: "Ingresa el nombre de la cotización",
        },
        CUSTOMER: {
            LABEL: "Cliente",
            PLACEHOLDER: "Selecciona cliente",
        },
        CONTACT: {
            LABEL: "Contacto",
            PLACEHOLDER: "Ingresa contacto",
        },
        ADDRESS: {
            LABEL: "Dirección",
            PLACEHOLDER: "Ingresa direccion",
        },
        EXPIRATION: {
            LABEL: "Vencimiento",
            PLACEHOLDER: "Ingresa vencimiento",
        },
        STATUS: {
            LABEL: "Estado",
            PLACEHOLDER: "Selecciona estado",
        },
        PHONE: {
            LABEL: "Teléfono",
            PLACEHOLDER: "Teléfono del cliente",
        },
        EMAIL: {
            LABEL: "Correo",
            PLACEHOLDER: "Correo del cliente",
        },
        NIT: {
            LABEL: "NIT",
            PLACEHOLDER: "NIT del cliente",
        },
    },
    SAVING_BUTTON: "Guardando...",
    DETAIL: {
        TITLE: "Deetalle de Cotización",
        ADD_ITEM: "Agregar Elemento",
        EMPTY: {
            TITLE: "Cotización sin elementos",
            DESCRIPTION: "Agrega productos o servicios para crear tu cotización",
        },
        TABLE: {
            KEY: "No",
            DESCRIPTION: "Categoria / Servicio",
            QTY: "Cant",
            PRICE: "Precio",
            TOTAL: "Total",
            ACTIONS: "Acciones",
        },
        FORM: {
            TITLE: "Elemento de Cotización",
            DESCRIPTION: {
                LABEL: "Descripción",
                PLACEHOLDER: "Ingresa descripción",
            },
            QTY: {
                LABEL: "Cant",
                PLACEHOLDER: "Ingresa cantidad",
            },
            PRICE: {
                LABEL: "Precio",
                PLACEHOLDER: "Ingresa precio",
            },
            TOTAL: {
                LABEL: "Total",
                PLACEHOLDER: "Ingresa total",
            },
            CANCEL: "Cancelar",
            ACCEPT: "Aceptar",
            GREATER_THAN_ZERO: (fieldName: string) => `${fieldName} debe ser mayor a 0`,
        },
        CHARACTERISTICS: "Características",
    },
    POLICY: {
        TITLE: "Terminos y Condiciones",
        ADD_ITEM: "Agregar Elemento",
        EMPTY: {
            TITLE: "Cotización sin terminos o condiciones",
            DESCRIPTION: "Agrega terminos o condiciones para crear tu cotización",
        },
        TABLE: {
            KEY: "No",
            DESCRIPTION: "Descripción",
            NAME: "Nombre",
            ACTIONS: "Acciones",
        },
        FORM: {
            TITLE: "Términos y Condiciones",
            DESCRIPTION: {
                LABEL: "Descripción",
                PLACEHOLDER: "Ingresa descripción",
            },
            NAME: {
                LABEL: "Nombre",
                PLACEHOLDER: "Ingresa nombre",
            },
            CANCEL: "Cancelar",
            ACCEPT: "Acceptar",
        },
    },
    TEMPLATE: {
        FORM: {
            TEMPLAT_NAME: {
                LABEL: "Diseño de Cotización",
                PLACEHOLDER: "Selecciona diseño de cotización",
            },
            SALUTATION: {
                LABEL: "Saludo",
                PLACEHOLDER: "Ingresa saludo",
            },
            BODY: {
                LABEL: "Cuerpo",
                PLACEHOLDER: "Ingresa cuerpo",
            },
            CLOSE: {
                LABEL: "Despedida",
                PLACEHOLDER: "Ingresa despedida",
            },
        },
        CANCEL: "Regresar",
        ACCEPT: "Vista Previa",
    },
    PREVIEW: {
        TITLE: "Vista Previa",
        RETURN: "Regresar",
        PRINT: "Imprimir",
    },
    RECORDS: {
        TITLE: "Cotizaciones",
        NEW_QUOTATION: "Nueva cotización",
        SEARCH: "Buscar cotizaciones",
        COLUMNS: {
            CODE: "Código",
            NAME: "Nombre",
            CUSTOMER: "Cliente",
            STATUS: "Estado",
            TOTAL: "Total",
            ACTIONS: "Acciones",
        },
        ACTIONS: {
            VIEW: "Ver",
            GENERATE_PDF: "Generar PDF",
            SEND_TELEGRAM: "Enviar a Telegram",
            APPROVE: "Aprobar",
            REJECT: "Rechazar",
            MARK_DRAFT: "Marcar como borrador",
            DELETE: "Eliminar",
            MENU: "Acciones",
        },
        CONFIRM: {
            APPROVE: "¿Aprobar cotización?",
            REJECT: "¿Rechazar cotización?",
            MARK_DRAFT: "¿Marcar cotización como borrador?",
            DELETE: "¿Eliminar cotización?",
            OK_APPROVE: "Aprobar",
            OK_REJECT: "Rechazar",
            OK_MARK_DRAFT: "Marcar borrador",
            OK_DELETE: "Eliminar",
            CANCEL: "Cancelar",
        },
        STATUS_VALUES: {
            DRAFT: "Borrador",
            SENT: "Enviada",
            APPROVED: "Aprobada",
            REJECTED: "Rechazada",
            DELETED: "Eliminada",
        },
    },
    PDF_ACTIONS: {
        TITLE: "Enviar",
        ACTION: "Acción",
        PDF_TITLE: "Generar PDF",
        TELEGRAM_TITLE: "Enviar a Telegram",
        TEMPLATE: "Diseño",
        SELECT_TEMPLATE: "Selecciona diseño",
        SHOW_PRICES: "Mostrar precios en propuesta",
        BACK: "Regresar",
        GENERATE_PDF: "Generar PDF",
        SEND_TELEGRAM: "Enviar a Telegram",
        SENT_SUCCESS: "Cotización enviada a Telegram",
        SAVE_FIRST: "Guarda la cotización antes de generar el PDF",
        SAVE_SUCCESS: "Cotización guardada",
        NO_ACTIVE_TEMPLATES: "No hay diseños activos disponibles.",
        ACTIVATE_TEMPLATE_HINT: "Activa un diseño de cotización antes de generar o enviar este documento.",
    },
}

export const createQuotationDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}
